export default __webpack_public_path__ + "static/media/1170.7334bed9.png";